import { useEffect, useState } from "react";
import "./PrefixItems.css";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import {
  deleteProductCategory,
  getProductCategory,
} from "../../services/productCategory";
import { DeleteModal } from "../modal/DeleteModal";
import {
  deleteCompanyPrefix,
  getCompanyPrefix,
} from "../../services/companyPrefix";

export const PrefixItems = ({ categoryAddedFlag, handleUpdate }) => {
  const [categories, setCategories] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  console.log("categoryAddedFlag: ", categoryAddedFlag);

  const fetchProductCategories = async () => {
    const data = await getCompanyPrefix();
    if (data === null) {
      alert("something went wrong, please try later");
      return;
    }
    setCategories(data);
    return;
  };

  useEffect(() => {
    fetchProductCategories();
  }, [categoryAddedFlag]);

  console.log("categoryItems: ", categories);

  const handleDelete = async (id) => {
    setDeleteId(id);
    setModalShow(true);
    return;
  };
  const confirmCategoryDelete = async () => {
    const res = await deleteCompanyPrefix(deleteId);
    if (res === null) {
      alert("something went wrong, please try later");
      setDeleteId(null);
      return;
    }

    setCategories((data) =>
      data.filter((category) => category.id !== deleteId)
    );
    setDeleteId(null);
    return;
  };

  console.log("deleteId: ", deleteId);

  return (
    <div>
      <Typography component="h1" variant="h5">
        <strong>Company Prefixes</strong>
      </Typography>
      <div className="itemContainer prefix">
        {categories?.map((category) => {
          return (
            <div className="items" key={category.id}>
              <div className="itemName">{`${category.company_name}  -  ${category.gs1_company_prefix}`}</div>
              <Stack direction="row">
                <IconButton
                  onClick={() => handleUpdate(category)}
                  aria-label="edit"
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton
                  onClick={() => handleDelete(category.id)}
                  aria-label="delete"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Stack>
            </div>
          );
        })}
      </div>

      {/* delete modal */}
      <DeleteModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        header="Delete Company Prefix"
        body="Delete company prefix? This can't be undo."
        confirmDelete={confirmCategoryDelete}
      />
    </div>
  );
};
